import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const isDev = process.env.NODE_ENV !== "production";

export default function AuthCallback() {
    const nav = useNavigate();
    const { setUser } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        const sessionId = match ? decodeURIComponent(match[1]) : null;
        if (!sessionId) {
            nav("/login", { replace: true });
            return;
        }
        const role = sessionStorage.getItem("jobsiq_google_role") || "seeker";
        sessionStorage.removeItem("jobsiq_google_role");

        (async () => {
            try {
                const { data } = await api.post("/auth/google/session", { session_id: sessionId, role });
                setUser(data.user);
                window.history.replaceState({}, "", "/dashboard");
                nav("/dashboard", { replace: true, state: { user: data.user } });
            } catch (e) {
                if (isDev) console.error("OAuth callback failed:", e);
                nav("/login", { replace: true });
            }
        })();
    }, [nav, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center text-slate-500 font-mono-plex text-sm" data-testid="auth-callback">
            Establishing secure session…
        </div>
    );
}
